module.exports = __webpack_public_path__ + "static/media/android.ce4f7ffd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/android.png
 ** module id = 210
 ** module chunks = 0
 **/